var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (false)?_c('div',{staticClass:"support-chat",attrs:{"id":"support-chat"}},[_c('img',{staticClass:"support-chat__icon",attrs:{"src":require("@/assets/images/SupportChat/icon.png"),"alt":"chat","srcset":""}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }